export default __webpack_public_path__ + "static/media/04.5aba1524.svg";